export default "__VITE_ASSET__DVu5nxto__"